import * as React from 'react';
import { cs } from '../utils/utils-classname';

export class CollapsiblePanel extends React.Component<
    {
        label: string | JSX.Element | ((isOpen) => JSX.Element);
        isOpen?: boolean;
        isLoading?: boolean;
        defaultIsOpen?: boolean;
        onToggle?: Function;
        animated?: boolean;
        disabledCursor?: boolean;
        isSubPanel?: boolean;
        baseClassName?: string;
        lazyLoad?: boolean;
        children?: React.ReactNode;
        panelStyle?: React.CSSProperties;
    },
    {
        isOpen: boolean;
    }
> {
    state = {
        isOpen: this.isControlled() ? this.props.isOpen : this.props.defaultIsOpen || false,
    };

    static defaultProps = {
        animated: true,
    };

    private body: HTMLElement;

    render() {
        return (
            <section className={cs('collapsible-panel', this.props.baseClassName, { open: this.isOpen(), 'overlay-loading': !!this.props.isLoading })}>
                <header className={cs('collapsible-panel__btn', { 'cursor-change': !this.props.disabledCursor })} onClick={this.toggle}>
                    <i className={cs('iki iki-chevron-right', { 'sub-icon-open': this.isOpen() && this.props.isSubPanel, 'sub-panel-icon': this.props.isSubPanel })} />
                    <span>{typeof this.props.label === 'function' ? this.props.label(this.state.isOpen) : this.props.label}</span>
                </header>
                <div className={cs('collapsible-panel__body', { animated: this.props.animated })} ref={el => (this.body = el)} style={this.props.panelStyle}>
                    {this.props.lazyLoad ? (this.isOpen() ? this.props.children : null) : this.props.children}
                </div>
            </section>
        );
    }

    componentDidMount() {
        this.updateHeight();
    }

    componentDidUpdate() {
        this.updateHeight();
    }

    updateHeight = _.debounce(() => {
        if (!this.body) return;
        const { style } = this.body;

        if (this.isOpen()) {
            if (this.props.animated) {
                style.maxHeight = (this.body.children[0] as HTMLElement).offsetHeight + 30 + 'px';
            } else {
                style.maxHeight = 'initial';
            }
            style.marginTop = '5px';
        } else {
            style.maxHeight = '0px';
            style.marginTop = '0px';
        }
    }, 10);

    toggle = () => {
        if (this.isControlled()) {
            if (typeof this.props.onToggle === 'function') {
                this.props.onToggle(!this.props.isOpen);
            }
        } else {
            const { isOpen } = this.state;

            this.setState({
                isOpen: !isOpen,
            });
        }
    };

    private isControlled() {
        return typeof this.props.isOpen !== 'undefined';
    }

    private isOpen() {
        return this.isControlled() ? this.props.isOpen : this.state.isOpen;
    }
}
